import React from 'react';
import { money, monthTx, MONTHS } from './financeUtils';

export const InvestmentPlan = ({ tx, view }) => {
  const salary = monthTx(tx, view)
    .filter((t) => t.type === 'income' && String(t.category || '').trim().toLocaleLowerCase('pt-BR') === 'salário')
    .reduce((s, t) => s + (Number(t.amount) || 0), 0);
  const monthly = Math.round(salary * 0.15 * 100) / 100;
  const ml = `${MONTHS[view.getMonth()]} ${view.getFullYear()}`;
  return (
    <section className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4" id="investimentos" data-testid="finance-investment">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <h3 className="font-semibold text-slate-900 text-sm">Seu plano de investimentos</h3>
          <p className="text-[11px] text-slate-500">Veja o que pode acumular investindo 15% do salário a cada mês.</p>
        </div>
        <span className="shrink-0 text-xs font-bold text-emerald-700 bg-emerald-50 rounded-lg px-2.5 py-1.5" data-testid="finance-investment-badge">15% de investimento</span>
      </div>
      <div className="bg-emerald-50/50 border border-emerald-100 rounded-xl p-3 mb-3">
        <p className="text-xs text-slate-600">
          {salary > 0 ? `15% de ${money(salary)} em salário registrado em ${ml}` : `Nenhum salário registrado em ${ml}. Cadastre uma entrada na categoria “Salário” para ver sua projeção.`}
        </p>
        <p className="text-xl font-bold text-emerald-700 my-1" data-testid="finance-investment-monthly">{salary > 0 ? money(monthly) : '—'}</p>
        <p className="text-[11px] text-slate-500">valor sugerido para investir mensalmente</p>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {[12, 24, 36].map((n) => (
          <div key={n} className="border border-slate-100 rounded-xl p-2.5" data-testid={`finance-investment-${n}`}>
            <p className="text-[11px] text-slate-500">Em {n} meses</p>
            <p className="text-[11px] font-bold text-slate-900 whitespace-nowrap tracking-tight">{salary > 0 ? money(Math.round(monthly * n * 100) / 100) : '—'}</p>
          </div>
        ))}
      </div>
      <p className="text-[10px] text-slate-400 mt-2">Projeções de economia acumulada, sem considerar juros ou rendimentos. Uma sugestão para planejamento, não uma recomendação financeira.</p>
    </section>
  );
};
